import { z as zod } from 'zod';

export const ImageForUploadSchema = zod.object({
  image: zod.instanceof(File),
  thumbnailArea: zod
    .object({
      x1: zod.number(),
      y1: zod.number(),
      x2: zod.number(),
      y2: zod.number(),
    })
    .optional(),
  altText: zod.string().optional(),
});
